import type { Article } from '../data/articles';

export const SITE_URL = 'https://www.contrastshower.com';
export const SITE_NAME = 'Contrast Shower';
export const DEFAULT_OG_IMAGE = '/images/blog-placeholder-basics.svg';

export function getAbsoluteUrl(path: string) {
  return new URL(path, SITE_URL).toString();
}

export function getArticlePath(slug: string) {
  return `/articles/${slug}`;
}

export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: getAbsoluteUrl('/images/logo-large.png'),
  };
}

export function buildCollectionSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${SITE_NAME} Articles`,
    url: getAbsoluteUrl('/articles'),
    description:
      'Practical articles on contrast showers, recovery, ice bath alternatives, and how to build a routine that actually sticks.',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}

export function buildFaqSchema(article: Article) {
  if (!article.faq.length) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: article.faq.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function buildBlogPostingSchema(article: Article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: article.title,
    description: article.seoDescription,
    image: [getAbsoluteUrl(article.image.src)],
    datePublished: article.publishedAt,
    dateModified: article.updatedAt,
    mainEntityOfPage: getAbsoluteUrl(getArticlePath(article.slug)),
    articleSection: article.category,
    keywords: article.keywords,
    author: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: getAbsoluteUrl('/images/logo-large.png'),
      },
    },
  };
}
